<h1 color="warn" mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    {{data.message}}
</div>
<div mat-dialog-actions>
    <button color="warn" mat-button (click)="onNoClick()" cdkFocusInitial>{{ 'general.button.no' | translate | uppercase }}</button>
    <span class="default-spacer"></span>
    <button mat-button (click)="onYesClick()">{{ 'general.button.yes' | translate | uppercase }}</button>
</div>